/* ==========================================================================
   Prix — ambientación Fiestas Patrias 2026
   Vive solo en el tema "Tienda Temática 18 septiembre". Al despublicar el
   tema desaparece completo: no hay nada que desmontar.

     1. Cuelga la guirnalda curva bajo el header (sin tocar header.liquid)
     2. Tira confeti tricolor al entrar a la sección del 18
     3. Suelta sorpresas cada cierto rato, solo en la home y la colección
     4. Hace aparecer las tarjetas al bajar
     5. Le pone latido a los números del contador cuando cambian

   Todo es opcional: si algo no está en la página, esa parte no corre.
   ========================================================================== */

(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     MODO PRUEBA — para revisar de cerca un personaje nuevo.

     Lo que esté en EN_PRUEBA sale al hacer scroll en la colección del 18,
     cada 2 segundos, y mientras tanto NO entra en la rotación normal. Cuando
     queda aprobado se pone EN_PRUEBA en null y pasa a salir como los demás.

     Acepta el nombre de un personaje ('remolino'), 'todos' para desfilarlos
     a todos en orden, o null para que no haya nada en prueba.

     Seguro: aunque quede encendido, se apaga solo cuando el tema pasa a ser
     el publicado (Shopify.theme.role === 'main').
     ---------------------------------------------------------------------- */
  var MODO_PRUEBA = false;
  var EN_PRUEBA = null;   // un nombre, 'todos', o null

  /* Cuánto vive en pantalla cada personaje. Tiene que alcanzar para que su
     animación termine: el trompo y el volantín cruzan la pantalla entera y
     necesitan sus buenos segundos. */
  var DURA = {
    empanada: 5600,
    remolino: 6600,
    volantin: 8400,
    confeti: 3200
  };

  var COLECCION = 'dieciocho';
  var COLORES = ['#d52b1e', '#ffffff', '#0039a6'];
  var SVG = 'http://www.w3.org/2000/svg';

  var menosMovimiento = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  function enModoPrueba() {
    if (!MODO_PRUEBA) return false;
    try {
      // si el tema está publicado, el modo prueba no corre pase lo que pase
      return !(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main');
    } catch (e) {
      return true;
    }
  }

  function enLaColeccionDel18() {
    return window.location.pathname.indexOf('/collections/' + COLECCION) !== -1;
  }

  /* ======================================================================
     1. Guirnalda colgada

     La cuerda es un path de curvas iguales: cuelga desde un punto, baja
     formando panza y vuelve a subir al siguiente punto. Las banderitas se
     ubican encima recorriendo el trazo con getPointAtLength(), y cada una
     se inclina con la pendiente que tiene la cuerda justo ahí.
     ====================================================================== */

  var TRAMO = 190;   // cada cuánto se cuelga la cuerda
  var PANZA = 28;    // cuánto baja en el medio
  var ARRIBA = 6;    // altura del punto de anclaje
  var PASO = 30;     // separación entre banderitas, medida en horizontal

  /* La cuerda son curvas cuadráticas con el control justo en el medio del
     tramo. Con el control centrado, la x avanza lineal con t, así que la
     curva tiene fórmula cerrada y no hace falta recorrer el arco:
        t = (x - x0) / TRAMO
        y = ARRIBA + 4 * PANZA * t * (1 - t)
        pendiente = 4 * PANZA * (1 - 2t) / TRAMO
     Espaciar por x (y no por largo de arco) es lo que deja las banderitas
     parejas a la vista: por arco se amontonan en las subidas. */
  function alturaEn(x) {
    var t = (x - Math.floor(x / TRAMO) * TRAMO) / TRAMO;
    return {
      y: ARRIBA + 4 * PANZA * t * (1 - t),
      giro: Math.atan2(4 * PANZA * (1 - 2 * t) / TRAMO, 1) * 180 / Math.PI
    };
  }

  function colgarGuirnalda() {
    var vieja = document.querySelector('.p18-guirnalda');
    if (vieja) vieja.remove();

    var header =
      document.querySelector('.header-wrapper') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('header');
    if (!header) return;

    var ancho = Math.ceil(document.documentElement.clientWidth || window.innerWidth);
    var alto = 66;

    var caja = document.createElement('div');
    caja.className = 'p18-guirnalda';
    caja.setAttribute('aria-hidden', 'true');   // es decoración, no contenido

    var svg = document.createElementNS(SVG, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + ancho + ' ' + alto);
    svg.setAttribute('preserveAspectRatio', 'none');
    caja.appendChild(svg);

    // un tramo de más a cada lado, para que nunca quede un borde pelado
    var tramos = Math.ceil(ancho / TRAMO) + 1;
    var d = 'M -' + TRAMO + ',' + ARRIBA;
    for (var t = -1; t < tramos; t++) {
      var x0 = t * TRAMO;
      d += ' Q ' + (x0 + TRAMO / 2) + ',' + (ARRIBA + PANZA * 2) +
           ' ' + (x0 + TRAMO) + ',' + ARRIBA;
    }

    var cuerda = document.createElementNS(SVG, 'path');
    cuerda.setAttribute('class', 'p18-cuerda');
    cuerda.setAttribute('d', d);
    svg.appendChild(cuerda);

    // los nuditos de donde cuelga
    for (var n = 0; n <= tramos; n++) {
      var nudo = document.createElementNS(SVG, 'circle');
      nudo.setAttribute('class', 'p18-nudo');
      nudo.setAttribute('cx', n * TRAMO);
      nudo.setAttribute('cy', ARRIBA);
      nudo.setAttribute('r', 2.5);
      svg.appendChild(nudo);
    }

    var tonos = ['roja', 'blanca', 'azul'];
    var i = 0;

    for (var x = -TRAMO; x <= ancho + PASO; x += PASO) {
      var punto = alturaEn(x);

      var g = document.createElementNS(SVG, 'g');
      g.setAttribute('transform', 'translate(' + x.toFixed(1) + ',' + punto.y.toFixed(1) + ')');

      var bandera = document.createElementNS(SVG, 'polygon');
      bandera.setAttribute('class', 'p18-bandera p18-bandera--' + tonos[i % 3]);
      bandera.setAttribute('points', '-11,0 11,0 0,24');
      bandera.style.setProperty('--giro', punto.giro.toFixed(1) + 'deg');
      // desfase por banderita: es lo que hace que la guirnalda se vea viva
      bandera.style.animationDelay = (-(i % 7) * 0.31).toFixed(2) + 's';

      g.appendChild(bandera);
      svg.appendChild(g);
      i++;
    }

    header.insertAdjacentElement('afterend', caja);
  }

  /* ======================================================================
     2. Confeti
     ====================================================================== */

  var confetiCorriendo = false;

  function confeti(opciones) {
    opciones = opciones || {};
    if (menosMovimiento || confetiCorriendo) return;
    confetiCorriendo = true;

    var DURACION = opciones.duracion || 6000;
    /* de dónde entra: arriba | izquierda | derecha | canon-izq | canon-der | canon-centro
       Los "canon" salen disparados desde abajo y la gravedad los devuelve, que es
       lo que se ve de fiesta de verdad. */
    var desde = opciones.desde || 'arriba';

    var canvas = document.createElement('canvas');
    canvas.className = 'p18-confeti';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var ancho, alto;

    function medir() {
      ancho = canvas.offsetWidth;
      alto = canvas.offsetHeight;
      canvas.width = ancho * dpr;
      canvas.height = alto * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    medir();
    window.addEventListener('resize', medir);

    // en pantallas chicas menos papelitos, para no ahogar el teléfono
    var base = ancho < 700 ? 60 : 110;
    var cuantos = Math.round(base * (opciones.densidad || 1));
    var papeles = [];

    var esCanon = desde.indexOf('canon') === 0;

    for (var i = 0; i < cuantos; i++) {
      var p = {
        w: 6 + Math.random() * 6,
        h: 9 + Math.random() * 8,
        color: COLORES[i % COLORES.length],
        vaiven: 0.5 + Math.random() * 1.2,
        fase: Math.random() * Math.PI * 2,
        giro: (Math.random() - 0.5) * 0.16,
        angulo: Math.random() * Math.PI,
        vx: 0,
        vy: 1.6 + Math.random() * 2.4,
        peso: 0,
        roce: 1
      };

      if (desde === 'izquierda') {
        p.x = -20 - Math.random() * 120;
        p.y = Math.random() * alto * 0.5;
        p.vx = 2.2 + Math.random() * 2;
        p.roce = 0.985;
      } else if (desde === 'derecha') {
        p.x = ancho + 20 + Math.random() * 120;
        p.y = Math.random() * alto * 0.5;
        p.vx = -(2.2 + Math.random() * 2);
        p.roce = 0.985;
      } else if (esCanon) {
        // sale disparado desde abajo en abanico y la gravedad lo devuelve
        var fuerza = 11 + Math.random() * 7;
        var apertura, hacia;
        if (desde === 'canon-izq')      { p.x = -10; apertura = -1.15; hacia = 0.55; }
        else if (desde === 'canon-der') { p.x = ancho + 10; apertura = -1.15; hacia = -0.55; }
        else                            { p.x = ancho / 2; apertura = -1.4; hacia = 0; }
        p.y = alto + 10;
        var ang = apertura + hacia + (Math.random() - 0.5) * 0.75;
        p.vx = Math.cos(ang) * fuerza * (desde === 'canon-der' ? -1 : 1);
        p.vy = Math.sin(ang) * fuerza;
        p.peso = 0.26;
        p.roce = 0.992;
      } else {
        p.x = Math.random() * ancho;
        p.y = -20 - Math.random() * alto * 0.6;
      }
      papeles.push(p);
    }

    var inicio = null;

    function cuadro(ahora) {
      if (inicio === null) inicio = ahora;
      var pasado = ahora - inicio;

      ctx.clearRect(0, 0, ancho, alto);

      // el final se desvanece en vez de cortarse de golpe
      var salida = Math.min(1200, DURACION * 0.3);
      ctx.globalAlpha = pasado > DURACION - salida
        ? Math.max(0, (DURACION - pasado) / salida)
        : 1;

      for (var i = 0; i < papeles.length; i++) {
        var p = papeles[i];
        p.vy += p.peso;                 // gravedad, solo en modo cañón
        p.vx *= p.roce;                 // el envión inicial se va apagando
        p.vy *= p.roce;
        p.fase += 0.03;
        p.x += p.vx + Math.sin(p.fase) * p.vaiven;
        p.y += p.vy;
        p.angulo += p.giro;

        if (p.y > alto + 30 && desde === 'arriba') {
          p.y = -20;
          p.x = Math.random() * ancho;
        }

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.angulo);
        ctx.fillStyle = p.color;
        // el escalado en Y simula el papelito dando vuelta sobre sí mismo
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.cos(p.fase)));
        ctx.restore();
      }

      if (pasado < DURACION) {
        requestAnimationFrame(cuadro);
      } else {
        window.removeEventListener('resize', medir);
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
        confetiCorriendo = false;
      }
    }

    requestAnimationFrame(cuadro);
  }

  /* Ráfaga corta, entrando por un lado distinto cada vez. */
  var LADOS = ['canon-izq', 'canon-der', 'canon-centro', 'izquierda', 'derecha', 'arriba'];
  var ultimoLado = -1;

  function confetiSuelto() {
    var i = Math.floor(Math.random() * LADOS.length);
    if (i === ultimoLado) i = (i + 1) % LADOS.length;   // que no repita el de recién
    ultimoLado = i;
    confeti({ duracion: DURA.confeti, densidad: 0.75, desde: LADOS[i] });
  }

  /* Una sola vez por sesión y por lugar, para que sea una gracia y no una
     molestia. Si el navegador bloquea sessionStorage, igual funciona. */
  function confetiUnaVez(donde) {
    var llave = 'p18-confeti-' + donde;
    try {
      if (sessionStorage.getItem(llave)) return;
      sessionStorage.setItem(llave, '1');
    } catch (e) { /* incógnito o cookies bloqueadas: se tira igual */ }
    confeti({ duracion: 6000 });
  }

  /* ======================================================================
     3. Sorpresas al bajar por la página
     ====================================================================== */

  /* La empanada viene partida en dos imágenes: el cuerpo por un lado y el
     brazo con la bandera por otro. Se superponen y solo gira la capa del
     brazo, con el punto de giro puesto en el hombro — por eso saluda de
     verdad en vez de menearse entera.

     Las URLs las deja theme.liquid en window.P18: este archivo es un asset
     estático y no pasa por Liquid. Si no llegaron, se salta y sale otro. */
  function empanadaSaluda() {
    var p = window.P18 || {};
    if (!p.empanadaCuerpo || !p.empanadaBrazo) return;

    var caja = document.createElement('div');
    caja.className = 'p18-sorpresa p18-empanada';
    caja.setAttribute('aria-hidden', 'true');
    caja.innerHTML =
      '<div class="p18-empanada__figura">' +
        '<img class="p18-empanada__brazo" src="' + p.empanadaBrazo + '" alt="">' +
        '<img class="p18-empanada__cuerpo" src="' + p.empanadaCuerpo + '" alt="">' +
      '</div>';

    document.body.appendChild(caja);
    setTimeout(function () { caja.remove(); }, DURA.empanada);
  }

  /* El remolino gira de verdad sobre su eje: son dos capas, las aspas atrás
     girando sobre el centro del botón, y el palito con el botón adelante,
     quietos. Un remolino gira en el plano de la imagen, así que esto es una
     rotación de verdad y no un truco. */
  function remolinoGira() {
    var p = window.P18 || {};
    if (!p.remolinoAspas || !p.remolinoEje) return;

    var caja = document.createElement('div');
    caja.className = 'p18-sorpresa p18-remolino';
    caja.setAttribute('aria-hidden', 'true');
    caja.innerHTML =
      '<div class="p18-remolino__figura">' +
        '<img class="p18-remolino__aspas" src="' + p.remolinoAspas + '" alt="">' +
        '<img class="p18-remolino__eje" src="' + p.remolinoEje + '" alt="">' +
      '</div>';

    document.body.appendChild(caja);
    setTimeout(function () { caja.remove(); }, DURA.remolino);
  }

  /* El volantín cruza la pantalla en diagonal, meciéndose con el viento. */
  function volantinCruza() {
    var url = (window.P18 || {}).volantin;
    if (!url) return;

    var caja = document.createElement('div');
    caja.className = 'p18-sorpresa p18-volantin';
    caja.setAttribute('aria-hidden', 'true');
    caja.innerHTML = '<img src="' + url + '" alt="">';

    document.body.appendChild(caja);
    setTimeout(function () { caja.remove(); }, DURA.volantin);
  }

  /* ======================================================================
     3. Sorpresas al bajar por la página
     ====================================================================== */

  /* Las sorpresas van por TIEMPO, no por scroll, y solo en la home y en la
     colección del 18. Por scroll salían en cualquier página y cada vez que
     alguien bajaba, que terminaba siendo invasivo.

     La primera aparece al rato de haber llegado, y después se espacian. Hay
     tope por página y por sesión, y no se dispara nada si la pestaña está en
     segundo plano: sería gastar una sorpresa que nadie ve. */

  var PRIMERA = 12000;      // cuánto espera la primera
  var ENTREMEDIO = 30000;   // cuánto espera entre una y otra
  var POR_PAGINA = 5;
  var POR_SESION = 12;

  /* Las sorpresas salen en toda la tienda. Lo que las hace llevaderas no es
     dónde salen, sino el ritmo: por tiempo, espaciadas y con tope. */
  function paginaConSorpresas() {
    return true;
  }

  function llevamosEnLaSesion() {
    try { return parseInt(sessionStorage.getItem('p18-sorpresas') || '0', 10); }
    catch (e) { return 0; }
  }

  function anotarSorpresa() {
    try { sessionStorage.setItem('p18-sorpresas', llevamosEnLaSesion() + 1); }
    catch (e) { /* incógnito: se pierde la cuenta, no es grave */ }
  }

  /* Todos los personajes, por nombre. El del modo prueba se saca de acá para
     que no salga por los dos lados a la vez. */
  function todosLosPersonajes() {
    return {
      empanada: { hacer: empanadaSaluda, clase: 'p18-empanada',        dura: DURA.empanada },
      remolino: { hacer: remolinoGira,   clase: 'p18-remolino',        dura: DURA.remolino },
      volantin: { hacer: volantinCruza,  clase: 'p18-volantin',        dura: DURA.volantin }
    };
  }

  /* Solo mientras dure el modo prueba, y solo en la colección del 18: los que
     estén en prueba desfilan uno tras otro, en orden y sin repetirse encima.

     Van encadenados SOLOS, sin tener que scrollear entre uno y otro: si había
     que scrollear para llamar al siguiente, bastaba con dejar de hacerlo para
     que los últimos de la fila no aparecieran nunca. El scroll igual sirve,
     pero para adelantar al que viene. */
  function desfileDePrueba(lista) {
    var cual = 0;
    var corriendo = false;

    function siguiente() {
      if (corriendo) return;
      corriendo = true;

      var quien = lista[cual % lista.length];
      cual++;
      quien.hacer();

      setTimeout(function () {
        corriendo = false;
        siguiente();
      }, quien.dura + 400);
    }

    siguiente();

    var esperando = false;
    window.addEventListener('scroll', function () {
      if (esperando) return;
      esperando = true;
      requestAnimationFrame(function () {
        esperando = false;
        siguiente();
      });
    }, { passive: true });
  }

  function sorpresasCadaTanto() {
    if (menosMovimiento) return;

    var personajes = todosLosPersonajes();

    var enPrueba = [];
    if (enModoPrueba() && EN_PRUEBA) {
      for (var n in personajes) {
        if (EN_PRUEBA === 'todos' || EN_PRUEBA === n) enPrueba.push(n);
      }
    }

    // los que están en prueba salen aparte, al scroll y solo en la colección.
    // El resto sigue con su ritmo normal, también acá.
    if (enPrueba.length && enLaColeccionDel18()) {
      desfileDePrueba(enPrueba.map(function (n) { return personajes[n]; }));
    }

    if (!paginaConSorpresas()) return;

    var pozo = [];
    for (var nombre in personajes) {
      if (enPrueba.indexOf(nombre) !== -1) continue;   // se está probando aparte
      pozo.push(personajes[nombre].hacer);
    }
    if (!pozo.length) return;    // están todos en prueba: no hay rotación normal
    for (var i = pozo.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = pozo[i]; pozo[i] = pozo[j]; pozo[j] = tmp;
    }

    var enEstaPagina = 0;

    function turno() {
      if (enEstaPagina >= POR_PAGINA || llevamosEnLaSesion() >= POR_SESION) return;

      if (document.hidden) {          // la pestaña está atrás: reintentar luego
        setTimeout(turno, 15000);
        return;
      }

      /* El personaje y el confeti salen JUNTOS, no por turnos. Turnándose se
         veía una tanda de confeti sola y después una empanada sola; así cada
         aparición es una sola escena y nunca hay confeti a secas. */
      pozo[enEstaPagina % pozo.length]();
      confetiSuelto();
      enEstaPagina++;
      anotarSorpresa();
      setTimeout(turno, ENTREMEDIO);
    }

    setTimeout(turno, PRIMERA);
  }

  /* ======================================================================
     4. Aparición al hacer scroll
     ====================================================================== */

  function prepararApariciones() {
    if (menosMovimiento || !('IntersectionObserver' in window)) return;

    var tarjetas = document.querySelectorAll(
      '.collection .grid__item, .card-wrapper, .featured-collection .grid__item'
    );
    if (!tarjetas.length) return;

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        entrada.target.classList.add('p18-visible');
        observador.unobserve(entrada.target);
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.05 });

    tarjetas.forEach(function (t) {
      t.classList.add('p18-aparece');
      observador.observe(t);
    });
  }

  /* ======================================================================
     5. Latido de los números del contador
     ====================================================================== */

  function animarContador() {
    if (menosMovimiento || !('MutationObserver' in window)) return;

    var numeros = document.querySelectorAll('[data-days], [data-hours], [data-minutes], [data-seconds]');
    if (!numeros.length) return;

    numeros.forEach(function (n) {
      new MutationObserver(function () {
        n.classList.remove('p18-late');
        void n.offsetWidth;          // reinicia la animación
        n.classList.add('p18-late');
      }).observe(n, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ======================================================================
     Arranque
     ====================================================================== */

  function arrancar() {
    colgarGuirnalda();
    prepararApariciones();
    animarContador();
    sorpresasCadaTanto();

    if (enLaColeccionDel18()) {
      document.body.classList.add('p18-coleccion');
      confetiUnaVez('coleccion');
      return;
    }

    // en la home, cuando el banner entra en pantalla
    if ('IntersectionObserver' in window) {
      var banner = document.querySelector('[class*="ai-responsive-banner"], .p18-banner');
      if (!banner) return;
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          confetiUnaVez('home');
          obs.disconnect();
        });
      }, { threshold: 0.4 });
      obs.observe(banner);
    }
  }

  // al cambiar el ancho hay que volver a dibujar la cuerda con los tramos justos
  var redibujar;
  window.addEventListener('resize', function () {
    clearTimeout(redibujar);
    redibujar = setTimeout(colgarGuirnalda, 220);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
